<template>
  <div
    class="lp-child-base"
    :class="hideAddvertise ? `lp-child-base--validCpno` : 'lp-child-base--invalidCpno'"
    :style="styles"
  >
    <block-hero :target-info="targetInfo" :color-scheme="colorScheme"/>
    <!-- <block-update-info :color-scheme="colorScheme" :lp-id="lpId" :target-info="targetInfo"/> -->
    <block-about-slider :target-info="targetInfo" :color-scheme="colorScheme" :lp-id="lpId"/>
    <block-three-years-later :color-scheme="colorScheme" :lp-id="lpId" :subsc-url="subscUrl" />
    <block-about-counselor :target-info="targetInfo" :color-scheme="colorScheme" :lp-id="lpId"/>
    <!-- <block-about-fortune :target-info="targetInfo" :color-scheme="colorScheme" :lp-id="lpId" :banner-type="bannerType"/> -->
    <!-- <block-banner-another :target-info="targetInfo" :color-scheme="colorScheme" :lp-id="lpId" ga-label="basecamp1"/> -->
    <!-- <block-sell :target-info="targetInfo" :color-scheme="colorScheme" :lp-id="lpId"/> -->
    <block-baika-shineki :color-scheme="colorScheme" :lp-id="lpId" :subsc-url="subscUrl" />
    <!-- <block-review :target-info="targetInfo" :color-scheme="colorScheme" :review-list="reviewListMod" :lp-id="lpId"/> -->
    <template v-if="!hideAddvertise">
    <!--<block-menus
        v-if="menusList && menusList.length"
        :target-info="targetInfo"
        :color-scheme="colorScheme"
        :menu-list="menusList"
        :tab-list="menusTabList"
        :lp-id="lpId"
        :subscr-enable="+salesInvalid > 0"
      /> -->
      <!-- <line-campaign-message :target-info="targetInfo" :color-scheme="colorScheme"/> -->
      <!--<block-banner
        class="block-banner--middle"
        v-if="showBanner"
        :lp-id="lpId"
        banner-pos="middle"
        :ga-event-categ="`LP${this.lpId}-LINE-campaign-banner`"
        :campaign="bannerType"
        :target-info="targetInfo"
        :color-scheme="colorScheme"
        :has-caption="false"
      /> -->
      <block-banner2
        class="block-banner--middle"
        :lp-id="lpId"
        banner-pos="middle"
        :campaign="bannerType"
        :target-info="targetInfo"
        :color-scheme="colorScheme"
        :has-caption="false"
        :subsc-url="subscUrl"
      />
      <block-uranai-tv
        :target-info="targetInfo"
        :color-scheme="colorScheme"
        :subsc-url="subscUrl"
        :lp-id="lpId"
        :is-individualed="true"
      />
    </template>
    <!--
    <block-banner
      v-if="showBanner"
      :lp-id="lpId"
      banner-pos="bottom"
      :color-scheme="colorScheme"
      :ga-event-categ="`LP${this.lpId}-LINE-campaign-banner`"
      :campaign="bannerType" :target-info="targetInfo" />
    <block-banner-another :target-info="targetInfo" :color-scheme="colorScheme" :lp-id="lpId" ga-label="basecamp2"/>
    -->
  </div>

</template>

<script>
import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton'
import BlockReview from '@/utvStore/components/recommend/lp/blocks/BlockReview'
import BlockMenus from './blocks/BlockMenus'
import BlockUranaiTv from '@/utvStore/components/recommend/lp/blocks/BlockUranaiTv'
import BlockHero from './blocks/BlockHero'
import BlockAboutCounselor from './blocks/BlockAboutCounselor'
import BlockAboutFortune from './blocks/BlockAboutFortune'
import BlockAboutSlider from './blocks/BlockAboutSlider'
import BlockBanner from '@/utvStore/components/recommend/lp/blocks/BlockBanner'
import BlockBanner2 from '@/utvStore/components/recommend/lp/blocks/BlockBanner2'
import LineCampaignMessage from '@/utvStore/components/recommend/lp/partials/LineCampaignMessage'
import BlockSell from './blocks/BlockSell'
import BlockThreeYearsLater from './blocks/BlockThreeYearsLater'
import BlockBaikaShineki from './blocks/BlockBaikaShineki'
import BlockBannerAnother from './blocks/BlockBannerAnother'
import BlockUpdateInfo from '@/utvStore/components/recommend/lp/blocks/BlockUpdateInfo'

export default {
  name: 'LpMain',
  components: {
    LpBaseButton,
    BlockHero,
    BlockAboutCounselor,
    BlockAboutFortune,
    BlockAboutSlider,
    BlockReview,
    BlockMenus,
    BlockUranaiTv,
    BlockBanner,
    BlockBanner2,
    LineCampaignMessage,
    BlockSell,
    BlockThreeYearsLater,
    BlockBaikaShineki,
    BlockBannerAnother,
    BlockUpdateInfo,
  },
  props: {
    lpId: {
      type: Number,
      default: 1,
    },
    menusList: {
      type: Array,
      default(){
        return []
      }
    },
    menusTabList: {
      type: Array,
      default(){
        return []
      }
    },
    targetInfo: {
      type: Object,
      default(){
        return {}
      }
    },
    reviewList: {
      type: Array,
      default(){
        return []
      }
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    hideAddvertise: {
      type: Boolean,
      default: false,
    },
    campaignMessage: {
      type: String,
      default: '',
    },
    bannerType: {
      type: String,
      default: 'LINE',
    },
    salesInvalid: {
      type: Number,
      default: 0,
    },
    subscUrl: String,
  },
  computed:{
    reviewListMod() {
      console.log('targetInfo:%O', this.targetInfo)
      return !!this.reviewList && this.reviewList.length > 0 ? this.reviewList : (!!this.targetInfo.reviews ? this.targetInfo.reviews : [])
    },
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
        '--mess-bg': this.colorScheme.messBg,
      }
    },
    showBanner() {
      return true
    },
  },
}
</script>

<style scoped lang="scss">
@import "../../../../../../../sass/commons/commonVariables.scss";
$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);
$l_col_mess_bg: var(--mess-bg);

.btn-base {
  width: 100%;
  padding: 20px;
}
.lp-child-base {
  color: #32373F;
  .block-review-base {
    background: #F3FEFF;
    padding-bottom: 14px;
  }
  &--validCpno {
    .block-review-base {
      padding-bottom: 0;
    }
  }
  &--invalidCpno {}
  .block-menu-base {
    padding-bottom: 22px;
  }
  .block-uranaitv-base {
    padding-top: 36px;
  }
  .block-banner--top {
    padding-bottom: 40px;
  }
  .block-banner--middle {
    background: #F3FEFF;
    padding: 18px 20px 60px;
  }
  .block-banner {
    padding: 40px 0 0;
    text-align: center;
    background: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/kurenotori/LpMain.vue